import { render, staticRenderFns } from "./GuppyChatQuoteMessageList.vue?vue&type=template&id=1fed57ac&"
import script from "./GuppyChatQuoteMessageList.vue?vue&type=script&lang=js&"
export * from "./GuppyChatQuoteMessageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports